function getTranslations(lang = 'se') {
  const isSE = lang === 'se';
  const translations = {
    TOP_BAR_TITLE: isSE
      ? 'Välkommen till vår nya Egen Insamling hub! Om du letar efter din befintliga insamling, '
      : '',
    TOP_BAR_BTN_LABEL: isSE ? 'klicka här' : '',
    BTN_CREATE_FUNDRAISER: isSE ? 'Starta en insamling' : '',
    BTN_GIVE_A_GIFT: isSE ? 'Ge en gåva' : '',
    BTN_CONTINUE: isSE ? 'Fortsätt' : '',
    FORM_REQUIRE_FIELD_EXPLANATION: isSE ? '* = Obligatorisk uppgift' : '',
    SHARING_BOX_BEFORE_NAME: isSE ? 'Hjälp' : '',
    SHARING_BOX_AFTER_NAME: isSE
      ? 'samla in mer till Hjärt-Lungfonden. Dela insamlingen med dina vänner!'
      : '',
    HLF_FUNDRAISERS_LISTING_TITLE: isSE ? 'mer från Hjärt-Lungfonden' : '',
    HOME_PAGE_MAIN_TITLE: isSE
      ? 'Egen insamling - hjälp fler hjärtan att klappa!'
      : '',
    HOME_PAGE_MAIN_DESCRIPTION: isSE
      ? 'Här startar du enkelt en insamling och bjuder in vänner och bekanta att hjälpa till'
      : '',
    IF_PAGE_OTHER_FUNDRAISERS_LISTING_TITLE: isSE ? 'Fler insamlingar' : '',
    IF_PAGE_LINK_HOME: isSE ? 'Tillbaka till startsidan' : '',
    IF_PAGE_RAISED_SO_FAR: isSE ? 'Insamlat hittills:' : '',
    IF_PAGE_RAISED_SO_FAR_CURRENCY: isSE ? 'kronor' : '',
    IF_PAGE_DESCRIPTION_TITLE: isSE ? 'Om insamlingen' : '',
  };

  return translations;
}

export { getTranslations };
